import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Layout } from "../components/Layout";
import { Services } from "../components/services";
import { useSEO } from "../hooks/useSEO";

export const ServicesPage = ({ data }) => {
  useSEO({
    title: "Freight Forwarding & Logistics Services Dubai | Transwave",
    description:
      "Sea freight, air freight, cargo handling, multi-modal transportation, shipping documentation and logistics support. Professional logistics services in Dubai, UAE by Transwave.",
    canonical: "https://www.transwaveshipping.com/services",
  });

  return (
    <Layout contactData={data.Contact}>
      {/* Page Hero — centered + service tag pills */}
      <div className="page-hero page-hero--services">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Our Services</h1>
            <p>Comprehensive shipping, freight forwarding, and logistics solutions across global markets</p>
            <div className="hero-service-tags" style={{ justifyContent: "flex-start" }}>
              <span className="hero-tag"><i className="fa fa-ship"></i> Sea Freight</span>
              <span className="hero-tag"><i className="fa fa-plane"></i> Air Freight</span>
              <span className="hero-tag"><i className="fa fa-truck"></i> Road Transport</span>
              <span className="hero-tag"><i className="fa fa-file-text-o"></i> Customs Clearance</span>
              <span className="hero-tag"><i className="fa fa-cubes"></i> Cargo Handling</span>
            </div>
            <nav className="page-breadcrumb" aria-label="breadcrumb">
              <Link to="/">Home</Link> <span>/</span> <span>Services</span>
            </nav>
          </motion.div>
        </div>
      </div>

      <Services data={data.Services} />

      {/* Service Detail Cards */}
      <div className="services-detail-section">
        <div className="container">
          <div className="section-header-modern">
            <span className="section-tag"><i className="fa fa-check-circle"></i> Full Coverage</span>
            <h2>Why Our Clients Choose Us</h2>
            <p>From FCL sea freight to last-mile delivery, we cover the full logistics chain</p>
          </div>
          <div className="row">
            {[
              { icon: "fa fa-ship", title: "FCL & LCL Sea Freight", text: "Full Container Load and Less than Container Load options from UAE ports to worldwide destinations." },
              { icon: "fa fa-plane", title: "Air Freight", text: "Time-critical shipments handled with care via major UAE airports and global airline partners." },
              { icon: "fa fa-truck", title: "Road Transport", text: "GCC and regional road freight with reliable transit times and full tracking." },
              { icon: "fa fa-file-text-o", title: "Customs Clearance", text: "Expert documentation and customs filing to keep shipments moving without delays." },
            ].map((item, i) => (
              <motion.div
                key={i}
                className="col-md-3 col-sm-6"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
              >
                <div className="services-detail-card">
                  <i className={item.icon}></i>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="page-cta">
        <div className="container text-center">
          <h3>Need a logistics solution?</h3>
          <p>Tell us about your shipment and we'll provide a competitive quote within 24 hours.</p>
          <Link to="/contact" className="btn btn-custom btn-lg">Request a Quote</Link>
        </div>
      </div>
    </Layout>
  );
};
